<div class="child-contact-info">
  @if (ready) {
    <div role="content" class="child-contact-info-content">
      @if (ready) {
        <se-po-add-child-contact-info #childContactInfo
          [persona]="persona"
          [description]="description"
        ></se-po-add-child-contact-info>
      }
      <div class="form-submit">
        <se-fe-button
          seFeDataEmphasis="high"
          seFeDataType="submit"
          [seFeDataFullWidth]="true"
          (click)="submit()"
        >Continue</se-fe-button>
      </div>
    </div>
  }
</div>
